import { User } from '../hooks/types'
import { getApiClient } from './apiClient'

export const fn = async (): Promise<{ data: User }> => {
  const response = await getApiClient().get('persons/me/plus')

  return response.data
}

export default fn
